import { createFileRoute } from '@tanstack/react-router';
import { JourneysExternalIntegrationHandoff } from '@/pages/workspaces/journeys/integrations/external-integration/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/:type` URL — what the directory cards link to.
 * Flag off it renders the embedded Ember host; flag on it forwards to the migrated URL.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the `journeys` segment, so
 * the resolver's bundle-aware branch can rebuild the target from the bundle prefix when the
 * `/workspaces/last` sentinel needs resolving.
 */
function JourneysExternalIntegrationRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysExternalIntegrationHandoff type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/$type')({
  component: JourneysExternalIntegrationRoute,
});
